import React from 'react';
import { IStormDoorColorOption } from '../../../entities-generated/common/storm-door-color-option';
import { StormDoorColor } from '../../../entities-generated/common/storm-door-color';
import { TextureSelector } from '../texture-selector';

interface IStormDoorColorSelectorProps {
  swatchSize: number,
  options: IStormDoorColorOption[];
  selected: StormDoorColor[];
  showLabels: boolean;
  onSelectionChanged?: (selected: StormDoorColor[]) => void;
  rootStyle?: React.CSSProperties | undefined;
}

const getSwatchKey = (option: IStormDoorColorOption) => option.id.toString();

const getColorOrImage = (option: IStormDoorColorOption) => {
  const parts = option.description.split('|');
  const media = parts.length > 1 ? parts[1] : '#FFF';
  return media;
}

const getValue = (option: IStormDoorColorOption) => option.id;

const getLabel = (option: IStormDoorColorOption) => {
  const parts = option.description.split('|');
  return parts[0];
}

export const StormDoorColorSelector: React.FunctionComponent<IStormDoorColorSelectorProps> = (props) => {

  return (
    <TextureSelector<IStormDoorColorOption, StormDoorColor>
      swatchSize={props.swatchSize}
      options={props.options}
      selected={props.selected}
      showLabels={props.showLabels}
      onSelectionChanged={props.onSelectionChanged}
      rootStyle={props.rootStyle}
      allowMultipleSelection={true}
      allowNoSelection={false}
      getSwatchKey={getSwatchKey}
      getColorOrImage={getColorOrImage}
      getValue={getValue}
      getLabel={getLabel}
      selectAllOptionsValue={StormDoorColor.Any}
    />
  );
};